import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { serverLocation } from 'src/app/globals';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(
    private _httpClient: HttpClient,
    private _tokenService: TokenService
  ) { }

  getIssueConclusion(issueId: number): Observable<Blob> {
    return this._httpClient.get(`${serverLocation}/api/report-server/issue-conclusion/${issueId}`, {
      headers: new HttpHeaders().set('Authorization', `Bearer ${this._tokenService.token}`),
      responseType: 'blob'
    });
  }

  getIssueOperationProtocol(issueId: number): Observable<Blob> {
    return this._httpClient.get(`${serverLocation}/api/report-server/operation-protocol/${issueId}`, {
      headers: new HttpHeaders().set('Authorization', `Bearer ${this._tokenService.token}`),
      responseType: 'blob'
    });
  }

  getOfferReport(offerId: number): Observable<Blob> {
    return this._httpClient.get(`${serverLocation}/api/report-server/offer-report/${offerId}`, {
      headers: new HttpHeaders().set('Authorization', `Bearer ${this._tokenService.token}`),
      responseType: 'blob'
    });
  }
}
